"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var msal_browser_1 = require("@azure/msal-browser");
var msal_react_1 = require("@azure/msal-react");
var React = require("react");
var react_1 = require("react");
var react_moment_1 = require("react-moment");
var reactstrap_1 = require("reactstrap");
var customer_1 = require("../../api/customer");
var authConfig_1 = require("../../authConfig");
require("../../styles/CustomerProfilePage.css");
var FileUploadButton_1 = require("../FileUploadButton");
var UpdateProfileButton_1 = require("./modals/UpdateProfileButton");
var CustomerProfilePage = function (props) {
    var authRequest = __assign({}, authConfig_1.loginRequest);
    var inProgress = msal_react_1.useMsal().inProgress;
    var uploadLogoUrl = authConfig_1.apiConfig.basePath + 'api/company/logo/';
    var _a = react_1.useState(0), id = _a[0], setId = _a[1];
    var _b = react_1.useState({
        id: 0,
        name: "",
        displayName: "",
        email: "",
        phoneNumber: "",
        status: "",
        address: { firstLine: "", secondLine: "", state: "" },
        industry: "",
        description: "",
        language: "",
        country: "",
        createdAt: "",
        modifiedAt: "",
        profilepic: ""
    }), data = _b[0], setData = _b[1];
    var onLoad = function () {
        if (props.id) {
            setId(props.id);
        }
        customer_1.fetchCustomer(props.id.toString()).then(function (result) { return setData(result); }).catch(console.error);
    };
    var uploadFileCallback = function (logoUrl) {
        var newData = data;
        newData.profilepic = logoUrl;
        setData(__assign({}, newData));
    };
    react_1.useEffect(function () {
        if (data.id == 0 && inProgress === msal_browser_1.InteractionStatus.None)
            onLoad();
    }, [inProgress, data, setData]);
    return (React.createElement(msal_react_1.MsalAuthenticationTemplate, { interactionType: msal_browser_1.InteractionType.Redirect, authenticationRequest: authRequest },
        React.createElement(reactstrap_1.Container, null,
            React.createElement(reactstrap_1.Row, null,
                React.createElement(reactstrap_1.Col, { sm: "4" },
                    React.createElement("div", { className: "padding-default" },
                        data.profilepic && data.profilepic.length > 0 ? React.createElement("img", { className: "logo-default padding-default", src: data.profilepic }) : React.createElement(React.Fragment, null),
                        React.createElement("span", { className: "padding-default" }, data.name)),
                    React.createElement("div", { className: "padding-default" },
                        React.createElement(FileUploadButton_1.FileUploadButton, { callback: uploadFileCallback.bind(_this), url: uploadLogoUrl + id })),
                    React.createElement("div", { className: "registration-activity-info" },
                        React.createElement("div", { className: "padding-default" },
                            React.createElement("h6", null,
                                "Registration:",
                                React.createElement(react_moment_1.default, { format: "DD MMM YYYY" }, data.createdAt))),
                        React.createElement("div", { className: "padding-default" },
                            React.createElement("h6", null,
                                "Latest Activity:",
                                React.createElement(react_moment_1.default, { format: "DD MMM YYYY" }, data.modifiedAt))))),
                React.createElement(reactstrap_1.Col, { sm: "8", className: "main-column" },
                    React.createElement("h5", { className: "padding-default card-title" }, "Company Profile"),
                    React.createElement("h6", { className: "subtitle" }, "Basic info like name and address that you use on nova platform "),
                    React.createElement("h6", { className: "padding-default card-title" }, "BASIC INFO"),
                    React.createElement(reactstrap_1.ListGroup, { flush: true },
                        React.createElement(reactstrap_1.ListGroupItem, { tag: "div" },
                            React.createElement(reactstrap_1.Row, null,
                                React.createElement(reactstrap_1.Col, { sm: "4" },
                                    React.createElement("span", { className: "listgroup-title" }, "Name")),
                                React.createElement(reactstrap_1.Col, { sm: "7" },
                                    React.createElement("span", { className: "listgroup-content" }, data.name)),
                                React.createElement(reactstrap_1.Col, { sm: "1" },
                                    React.createElement(UpdateProfileButton_1.default, { id: props.id }, '>')))),
                        React.createElement(reactstrap_1.ListGroupItem, { tag: "div" },
                            React.createElement(reactstrap_1.Row, null,
                                React.createElement(reactstrap_1.Col, { sm: "4" },
                                    React.createElement("span", { className: "listgroup-title" }, "Display Name")),
                                React.createElement(reactstrap_1.Col, { sm: "7" },
                                    React.createElement("span", { className: "listgroup-content" }, data.displayName)),
                                React.createElement(reactstrap_1.Col, { sm: "1" },
                                    React.createElement(UpdateProfileButton_1.default, { id: props.id }, '>')))),
                        React.createElement(reactstrap_1.ListGroupItem, { tag: "div" },
                            React.createElement(reactstrap_1.Row, null,
                                React.createElement(reactstrap_1.Col, { sm: "4" },
                                    React.createElement("span", { className: "listgroup-title" }, "Email/Username")),
                                React.createElement(reactstrap_1.Col, { sm: "7" },
                                    React.createElement("span", { className: "listgroup-content" }, data.email)),
                                React.createElement(reactstrap_1.Col, { sm: "1" },
                                    React.createElement(UpdateProfileButton_1.default, { id: props.id }, '>')))),
                        React.createElement(reactstrap_1.ListGroupItem, { tag: "div" },
                            React.createElement(reactstrap_1.Row, null,
                                React.createElement(reactstrap_1.Col, { sm: "4" },
                                    React.createElement("span", { className: "listgroup-title" }, "Phone Number")),
                                React.createElement(reactstrap_1.Col, { sm: "7" },
                                    React.createElement("span", { className: "listgroup-content" }, data.phoneNumber)),
                                React.createElement(reactstrap_1.Col, { sm: "1" },
                                    React.createElement(UpdateProfileButton_1.default, { id: props.id }, '>')))),
                        React.createElement(reactstrap_1.ListGroupItem, { tag: "div" },
                            React.createElement(reactstrap_1.Row, null,
                                React.createElement(reactstrap_1.Col, { sm: "4" },
                                    React.createElement("span", { className: "listgroup-title" }, "Status")),
                                React.createElement(reactstrap_1.Col, { sm: "8" },
                                    React.createElement("span", { className: "listgroup-content" }, data.status)))),
                        React.createElement(reactstrap_1.ListGroupItem, { tag: "div" },
                            React.createElement(reactstrap_1.Row, null,
                                React.createElement(reactstrap_1.Col, { sm: "4" },
                                    React.createElement("span", { className: "listgroup-title" }, "Address")),
                                React.createElement(reactstrap_1.Col, { sm: "7" },
                                    React.createElement("span", { className: "listgroup-content" },
                                        data.address.firstLine,
                                        " ",
                                        data.address.secondLine,
                                        " ",
                                        data.address.state)),
                                React.createElement(reactstrap_1.Col, { sm: "1" },
                                    React.createElement(UpdateProfileButton_1.default, { id: props.id }, '>')))),
                        React.createElement(reactstrap_1.ListGroupItem, { tag: "div" },
                            React.createElement(reactstrap_1.Row, null,
                                React.createElement(reactstrap_1.Col, { sm: "4" },
                                    React.createElement("span", { className: "listgroup-title" }, "Industry")),
                                React.createElement(reactstrap_1.Col, { sm: "7" },
                                    React.createElement("span", { className: "listgroup-content" }, data.industry)),
                                React.createElement(reactstrap_1.Col, { sm: "1" },
                                    React.createElement(UpdateProfileButton_1.default, { id: props.id }, '>')))),
                        React.createElement(reactstrap_1.ListGroupItem, { tag: "div" },
                            React.createElement(reactstrap_1.Row, null,
                                React.createElement(reactstrap_1.Col, { sm: "4" },
                                    React.createElement("span", { className: "listgroup-title" }, "Description")),
                                React.createElement(reactstrap_1.Col, { sm: "7" },
                                    React.createElement("span", { className: "listgroup-content" }, data.description)),
                                React.createElement(reactstrap_1.Col, { sm: "1" },
                                    React.createElement(UpdateProfileButton_1.default, { id: props.id }, '>'))))),
                    React.createElement("h6", { className: "padding-default card-title" }, "PREFERENCE"),
                    React.createElement(reactstrap_1.ListGroup, { flush: true },
                        React.createElement(reactstrap_1.ListGroupItem, { tag: "div" },
                            React.createElement(reactstrap_1.Row, null,
                                React.createElement(reactstrap_1.Col, { sm: "4" },
                                    React.createElement("span", { className: "listgroup-title" }, "Language")),
                                React.createElement(reactstrap_1.Col, { sm: "7" },
                                    React.createElement("span", { className: "listgroup-content" }, data.language)),
                                React.createElement(reactstrap_1.Col, { sm: "1" },
                                    React.createElement(UpdateProfileButton_1.default, { id: props.id }, '>')))),
                        React.createElement(reactstrap_1.ListGroupItem, { tag: "div" },
                            React.createElement(reactstrap_1.Row, null,
                                React.createElement(reactstrap_1.Col, { sm: "4" },
                                    React.createElement("span", { className: "listgroup-title" }, "Country")),
                                React.createElement(reactstrap_1.Col, { sm: "7" },
                                    React.createElement("span", { className: "listgroup-content" }, data.country)),
                                React.createElement(reactstrap_1.Col, { sm: "1" },
                                    React.createElement(UpdateProfileButton_1.default, { id: props.id }, '>'))))))))));
};
exports.default = CustomerProfilePage;
//# sourceMappingURL=CustomerProfilePage.js.map